import { TDevice } from '@cian/utils';
import { ESiteType } from '../constants/siteType';

export function getSiteType(deviceType: TDevice) {
  return deviceType === 'phone' ? ESiteType.mobile : ESiteType[deviceType];
}
